import {QuestionList} from '../../types';
import Img from '../../img/scenes/page_09.jpg'

export const Day5: QuestionList = [{
    id: 101,
    img: Img,
    question: `Сьогодні ви працювали з Uklon Driver зранку, а вдень займатися своїми справами. Раптом, до вас зателефонувала одна з пасажирок і в сльозах і розповіла, що десь загубила обручку. Дуже просить якнайшвидше пошукати в салоні вашого авто.`,
    answers: [
        {
            id: 1,
            text: 'Пошукати, відклавши справи',
            next: 102,
        },
        {
            id: 2,
            text: 'Піти шукати за кілька годин, коли ви звільнитесь',
            next: 201,
        },
    ],
},
    {
        id: 201,
        question: `Дівчина справді загубила обручку у вашій автівці. Ви телефонуєте їй з хорошими новинами. Говорите, що вона може приїхати й забрати свою коштовність. Ви вже вільні, тому везете коштовність і намагаєтесь розрадити її жартами, поки віддаєте обручку.`,
        answers: [
            {
                id: 1,
                text: 'Далі',
                next: 202,
            },
        ],
    },
    {
        id: 202,
        question: `Ви отримуєте за поїздку туди і назад в сусідній район 400 грн готівкою, а у якості винагороди – 5 зірок за ранкову поїздку у застосунку.`,
        rate: 5,
        answers: [
            {
                id: 1,
                text: 'Працюю далі',
                next: 0,
            },
        ],
    },
    {
        id: 102,
        question: `Дівчина справді загубила обручку у вашій автівці. Ви телефонуєте їй з хорошими новинами і кажете, що вона може приїхати і забрати свою коштовність. `,
        answers: [
            {
                id: 1,
                text: 'Далі',
                next: 103,
            },
        ],
    },
    {
        id: 103,
        question: `Пасажирка дякує і радіє, але просить вас привезти їй обручку прямо зараз, а вона оплатить дорогу и навіть передасть винагороду. Каже, що це терміново, бо у неї дуже авторитарний чоловік і щойно він помітить її без обручки, буде халепа. Ви?`,
        answers: [
            {
                id: 1,
                text: 'Пояснюєте, що у вас за пів години зустріч, але замовите сервіс «Доставка» в Uklon. Тож інший водій привезе обручку. Ви ретельно запакуєте коштовність і передасте жінці контакти водія',
                next: 104,
            },
            {
                id: 1,
                text: 'Завозите річ прямо зараз',
                next: 105,
            },
        ],
    },
    {
        id: 104,
        question: `Все завершується чудово. Отримуєте схвальний відгук за ранкову поїздку від вдячної пасажирки.`,
        rate: -1,
        answers: [
            {
                id: 1,
                text: 'Працюю далі',
                next: 0,
            },
        ],
    },
    {
        id: 105,
        question: `Отримуєте 5 зірок за ранкову поїздку і 50 грн чайових.`,
        rate: 5,
        answers: [
            {
                id: 1,
                text: 'Працюю далі',
                next: 0,
            },
        ],
    },

];
